<div class="list-wrapper overflow-visible">
  @for (ganamigos of ganamigosNetwork; track ganamigos.id) {
    <div class="item" (click)="onGanamigosClick(ganamigos)">
      <div class="left-side">
        <app-user-avatar
          [size]="40"
          [avatarUrl]="getAvatarUrl(ganamigos)"
          [profileColor]="ganamigos?.profile_color"
          [initials]="getInitials(ganamigos)"
        ></app-user-avatar>
        <div class="user-info">
          <span class="paragraph-medium regular font-medium">{{ ganamigos.full_name }}</span>
          <span class="paragraph-small regular">{{ ganamigos.status }}</span>
        </div>
      </div>
      <div class="right-side flex">
        <button nz-button nzType="text" class="tooltip-button" (click)="onSendMessageClick($event, ganamigos)">
          <i nz-icon class="mr-2">
            <span class="tooltip-content">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 30 31"
                fill="none"
                class="w-[25px] md:w-[30px] h-[25px] md:h-[30px]"
              >
                <path
                  d="M7.1141 15.4994L2.87123 4.58913C2.57595 3.82979 3.31637 3.10362 4.04882 3.36174L4.16426 3.41082L26.6642 14.6608C27.3121 14.9848 27.3526 15.8716 26.7857 16.2659L26.6642 16.3379L4.16426 27.5879C3.43553 27.9523 2.6439 27.2823 2.83307 26.529L2.87123 26.4095L7.1141 15.4994ZM5.4997 6.17484L8.76093 14.5611L17.0454 14.5619C17.5201 14.5619 17.9123 14.9145 17.9743 15.3721L17.9829 15.4994C17.9829 15.974 17.6302 16.3663 17.1726 16.4283L17.0454 16.4369L8.76093 16.4361L5.4997 24.8239L24.1487 15.4994L5.4997 6.17484Z"
                  fill="#393E44"
                />
              </svg>
              <span class="text-xs sm:text-sm outfit font-medium tooltip-text tooltip-text-send-message">{{
                'ganamigos.sendMessage' | translate
              }}</span>
            </span>
          </i>
        </button>
        @if (shouldShowShareGanas(ganamigos)) {
          <button nz-button nzType="text" class="tooltip-button" (click)="onShareGanasClick($event, ganamigos)">
            <i nz-icon>
              <span class="tooltip-content">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 30 31"
                  fill="none"
                  class="w-[25px] md:w-[30px] h-[25px] md:h-[30px]"
                >
                  <path
                    d="M21.25 2.37305C23.6675 2.37305 25.6273 4.33278 25.6273 6.75026C25.6273 9.16772 23.6675 11.1275 21.25 11.1275C19.9625 11.1275 18.8049 10.5716 18.004 9.68685L12.3057 12.9424C12.4348 13.3554 12.5044 13.7947 12.5044 14.2502C12.5044 14.7059 12.4348 15.1451 12.3057 15.5581L18.0029 18.815C18.8038 17.9294 19.9619 17.373 21.25 17.373C23.6675 17.373 25.6273 19.3327 25.6273 21.7502C25.6273 24.1677 23.6675 26.1275 21.25 26.1275C18.8325 26.1275 16.8728 24.1677 16.8728 21.7502C16.8728 21.2947 16.9424 20.8554 17.0715 20.4424L11.3744 17.1856C10.5734 18.0711 9.41529 18.6275 8.12721 18.6275C5.70975 18.6275 3.75 16.6677 3.75 14.2502C3.75 11.8327 5.70975 9.87305 8.12721 9.87305C9.41466 9.87305 10.5723 10.4289 11.3732 11.3137L17.0715 8.05813C16.9424 7.64512 16.8728 7.20582 16.8728 6.75026C16.8728 4.33278 18.8325 2.37305 21.25 2.37305ZM21.25 19.248C19.8681 19.248 18.7478 20.3684 18.7478 21.7502C18.7478 23.1322 19.8681 24.2525 21.25 24.2525C22.6319 24.2525 23.7523 23.1322 23.7523 21.7502C23.7523 20.3684 22.6319 19.248 21.25 19.248ZM8.12721 11.748C6.74528 11.748 5.625 12.8684 5.625 14.2502C5.625 15.6322 6.74528 16.7525 8.12721 16.7525C9.50914 16.7525 10.6294 15.6322 10.6294 14.2502C10.6294 12.8684 9.50914 11.748 8.12721 11.748ZM21.25 4.24805C19.8681 4.24805 18.7478 5.36832 18.7478 6.75026C18.7478 8.13218 19.8681 9.25246 21.25 9.25246C22.6319 9.25246 23.7523 8.13218 23.7523 6.75026C23.7523 5.36832 22.6319 4.24805 21.25 4.24805Z"
                    fill="#505760"
                  />
                </svg>
                <span class="text-xs sm:text-sm outfit font-medium tooltip-text tooltip-text-share-ganas">{{
                  'ganamigos.shareGanas' | translate
                }}</span>
              </span>
            </i>
          </button>
        }
      </div>
    </div>
  }
</div>
